<template>
  <div class="editor-title">
    <h4>{{ t("message.keys") }}</h4>
  </div>
  <ul>
    <li class="editor-element">
      <h2 class="row text-start">
        <div class="col-5">{{ t("message.color") }}</div>
        <div class="col-7">
          <transition name="fade">
            <button
              class="btn btn-outline-lcn"
              v-if="!showPicker"
              @click="newKey('solid'), (showPicker = true)"
            >
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.fadeIn") }}
            </button>
          </transition>
        </div>
      </h2>
      <div class="content-expand">
        <transition name="fade">
          <div v-if="showPicker">
            <div class="color-picker-container">
              <MyCp
                @update="changeColor"
                @mouseup="mouseUp"
                :id="'color-picker-inlaybg'"
                :pColor="{
                  type: 'solid',
                  color:
                    selectedBtns.length > 0
                      ? inlayBtns[selectedBtns[0]].style.background
                      : '',
                }"
              ></MyCp>
            </div>
            <div class="mt-3">
              <button
                class="btn btn-outline-lcn me-2"
                @click="updateBtn('background', 'transparent')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.colorRemove") }}
              </button>
              <button class="btn btn-outline-lcn" @click="showPicker = false">
                <font-awesome-icon
                  :icon="['far', 'eye-slash']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.fadeOut") }}
              </button>
            </div>
          </div>
        </transition>
      </div>
    </li>
    <li class="topic-separator">
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.color-gradient") }}</div>
        <div class="col-7">
          <transition name="fade">
            <div v-if="!showG1 && !showG2">
              <button class="btn btn-outline-lcn" @click="showG1 = true">
                <font-awesome-icon
                  :icon="['far', 'eye']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.fadeIn") }}
              </button>
            </div>
          </transition>
        </div>
      </h2>
      <div class="content-expand">
        <transition name="fade">
          <div v-if="showG1">
            <div>
              <div class="color-picker-container">
                <MyCp
                  @update="gradientChange('firstColour', $event)"
                  @mouseup="mouseUp"
                  :id="'color-picker-inlaybtn1'"
                  :pColor="{
                    type: 'gradient',
                    color:
                      selectedBtns.length > 0
                        ? inlayBtns[selectedBtns[0]].style.background
                        : '',
                    gradient: 1,
                  }"
                ></MyCp>
              </div>
              <div
                class="btn btn-outline-lcn m-2"
                @click="(gradient.firstC = ''), gradientChange('firstC', '')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.colorRemove") }}
              </div>
              <div
                class="btn btn-outline-lcn m-2"
                @click="
                  showG1 = false;
                  showG2 = true;
                "
              >
                <font-awesome-icon
                  :icon="['far', 'eye']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.secondColor") }}
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="showG2">
            <div>
              <div class="color-picker-container">
                <MyCp
                  @update="gradientChange('secondColour', $event)"
                  @mouseup="mouseUp"
                  :id="'color-picker-inlaybtn2'"
                  :pColor="{
                    type: 'gradient',
                    color:
                      selectedBtns.length > 0
                        ? inlayBtns[selectedBtns[0]].style.background
                        : '',
                    gradient: 2,
                  }"
                ></MyCp>
              </div>

              <div
                class="btn btn-outline-lcn m-2"
                @click="(gradient.secondC = ''), gradientChange('secondC', '')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.colorRemove") }}
              </div>
              <div
                class="btn btn-outline-lcn m-2"
                @click="
                  showG2 = false;
                  showG1 = true;
                "
              >
                <font-awesome-icon
                  :icon="['far', 'eye']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.firstColor") }}
              </div>
            </div>
          </div>
        </transition>
        <div v-if="showG1 || showG2">
          <button
            class="btn btn-outline-lcn m-2"
            @click="
              showG1 = false;
              showG2 = false;
            "
          >
            <font-awesome-icon
              :icon="['far', 'eye-slash']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.fadeOut") }}
          </button>
        </div>
      </div>
    </li>
    <li class="topic-separator">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.icons") }}</div>
        <div class="col-7">
          <transition name="fade">
            <button
              class="btn btn-outline-lcn"
              v-if="!showGallery"
              @click="showGallery = true"
            >
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.fadeIn") }}
            </button>
          </transition>
        </div>
      </h2>
      <div class="content-expand">
        <transition name="fade">
          <div v-if="showGallery">
            <div class="pe-3 image-library" @click="expandImgLib('light')">
              <img
                :src="imgURL('light/Licht_3.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.light") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('security')">
              <img
                :src="imgURL('security/Zutritt_1.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.access") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('climate')">
              <img
                :src="imgURL('climate/Klima_4.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.climate") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('windows')">
              <img
                :src="imgURL('windows/Fenster_1.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.window") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('central')">
              <img
                :src="imgURL('central/Zentral_1.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.central-control") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('media')">
              <img
                :src="imgURL('media/Media_23.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.media") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('others')">
              <img
                :src="imgURL('others/Sonstige_8.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.other") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('connection')">
              <img
                :src="imgURL('connection/Connect_4.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.connection") }}</p>
            </div>
            <div class="pe-3 image-library" @click="expandImgLib('hotel')">
              <img
                :src="imgURL('hotel/Hotel_1.svg')"
                alt=""
                height="40"
                width="40"
              />
              <p>{{ t("message.hotel") }}</p>
            </div>
            <div class="row">
              <div class="col-5 text-start">Icon-{{ t("message.color") }}</div>
              <div class="row justify-content-center">
                <div
                  class="col-1 swatch-el"
                  v-for="(color, index) in swatchColors"
                  :key="'color_' + index"
                  :style="{ 'background-color': color.hex }"
                  @click="filterIcon(color.filter)"
                ></div>
                <div
                  class="col-1 swatch-el"
                  @click="
                    filterIcon(
                      'invert(100%) sepia(100%) saturate(0%) hue-rotate(314deg) brightness(109%) contrast(101%)'
                    )
                  "
                ></div>
              </div>
            </div>
            <div class="">
              <button
                class="btn btn-outline-lcn me-1"
                @click="updateBtnImg('background-image', '')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.imgRemove") }}
              </button>
              <button
                class="btn btn-outline-lcn"
                @click="
                  showGallery = false;
                  showImgLib = false;
                "
              >
                <font-awesome-icon
                  :icon="['far', 'eye-slash']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.fadeOut") }}
              </button>
            </div>
          </div>
        </transition>
      </div>
    </li>
    <li class="editor-element">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.imgEdit") }}</h2>
      <div class="content-expand">
        <div class="row">
          <div class="col-5 text-start">
            <div>{{ t("message.imgScale") }}</div>
          </div>
          <div class="col-7">
            <div class="img-edit d-inline pe-2">
              <font-awesome-icon
                :icon="['fas', 'plus']"
                class="icon"
                size="lg"
                @click="scaleBgImg(10)"
              ></font-awesome-icon>
            </div>
            <div class="img-edit d-inline">
              <font-awesome-icon
                :icon="['fas', 'minus']"
                class="icon"
                size="lg"
                @click="scaleBgImg(-10)"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-start">
            <div>{{ t("message.position") }}</div>
          </div>
          <div class="col-7">
            <div class="row justify-content-center">
              <div class="col-1 img-edit">
                <b-icon-arrow-up-left-circle
                  @click="updateBtnImg('background-position', 'top left')"
                ></b-icon-arrow-up-left-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-arrow-up-circle
                  @click="updateBtnImg('background-position', 'top')"
                ></b-icon-arrow-up-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-arrow-up-right-circle
                  @click="updateBtnImg('background-position', 'top right')"
                ></b-icon-arrow-up-right-circle>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-1 img-edit">
                <b-icon-arrow-left-circle
                  @click="updateBtnImg('background-position', 'left')"
                ></b-icon-arrow-left-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-circle
                  @click="updateBtnImg('background-position', 'center')"
                ></b-icon-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-arrow-right-circle
                  @click="updateBtnImg('background-position', 'right')"
                ></b-icon-arrow-right-circle>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-1 img-edit">
                <b-icon-arrow-down-left-circle
                  @click="updateBtnImg('background-position', 'bottom left')"
                ></b-icon-arrow-down-left-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-arrow-down-circle
                  @click="updateBtnImg('background-position', 'bottom')"
                ></b-icon-arrow-down-circle>
              </div>
              <div class="col-1 img-edit">
                <b-icon-arrow-down-right-circle
                  @click="updateBtnImg('background-position', 'bottom right')"
                ></b-icon-arrow-down-right-circle>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li class="topic-separator">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.border") }}</h2>
      <div class="content-expand">
        <div class="row">
          <div class="text-start col-5">
            {{ t("message.outlines") }}
          </div>
          <div class="col-7 text-start">
            {{ t("message.round") }}
            <input
              type="radio"
              class="form-check-input"
              :checked="
                selectedBtns.length > 0 &&
                inlayBtns[selectedBtns[0]].style['border-radius'] == '7px'
              "
              name="radius"
              @change="updateBtn('border-radius', '7px')"
              @click="updateBtn('border-radius', '7px')"
            />
            {{ t("message.angled") }}
            <input
              type="radio"
              class="form-check-input"
              :checked="
                selectedBtns.length > 0 &&
                inlayBtns[selectedBtns[0]].style['border-radius'] != '7px'
                  ? true
                  : false
              "
              name="radius"
              @change="updateBtn('border-radius', '0px')"
              @click="updateBtn('border-radius', '0px')"
            />
          </div>
        </div>
        <div>
          <div class="row">
            <div class="text-start col-5">{{ t("message.color") }}</div>
            <div class="col-7 text-start">
              <div class="d-inline-flex pb-1">
                <div
                  class="border-color col-1"
                  style="background: black"
                  @click="updateBtn('border', '1px solid black')"
                ></div>
                <div
                  class="border-color"
                  style="background: grey"
                  @click="updateBtn('border', '1px solid grey')"
                ></div>
                <div
                  class="border-color"
                  style="background: white"
                  @click="updateBtn('border', '1px solid white')"
                ></div>
              </div>
              <button
                class="btn btn-outline-lcn"
                @click="updateBtn('border', '')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.noBorder") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li class="topic-separator">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.changeMode") }}</div>
        <div class="col-7">
          <button class="btn btn-outline-lcn" @click="changeMode">
            {{
              inlayBtns[0].draggable
                ? t("message.deactivate")
                : t("message.activate")
            }}
          </button>
        </div>
      </h2>
      <div class="content-expand"></div>
    </li>
    <li class="topic-separator">
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.buttonSelection") }}</div>
        <div class="col-7">
          <button class="btn btn-outline-lcn" @click="selectAllBtns">
            {{
              inlayBtns.length > selectedBtns.length
                ? t("message.selectAll")
                : t("message.deselectAll")
            }}
          </button>
        </div>
      </h2>
    </li>
    <!-- <li class="topic-separator">
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.duplicateButtons") }}</div>
        <div class="col-7">
          <button class="btn btn-outline-lcn" @click="duplicateButton">
            {{ t("message.duplicateThisButton") }}
          </button>
          <template v-if="duplicating">
            <p>{{ t("message.selectTargetButtons") }}</p>
          </template>
        </div>
      </h2>
    </li> -->
  </ul>
  <icon-modal
    v-if="showImgLib"
    :library="library"
    @close="showImgLib = false"
  ></icon-modal>
</template>

<script>
import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import IconModal from "@/views/editors/editor-components/IconModal.vue";
import MyCp from "@/views/editors/editor-components/ColorPicker.vue";

export default {
  components: {
    IconModal,
    MyCp,
  },
  setup() {
    const library = ref("");
    const buttonBGKey = reactive({
      solid: "solid_key",
      gradient_1: "gradient_1_key",
      gradient_2: "gradient_2_key",
    });
    function newKey(key) {
      buttonBGKey[key] += "_" + Math.floor(Math.random() * (100 - 1 + 1)) + 1;
    }
    const swatchColors = [
      {
        hex: "#ff0000",
        filter:
          "invert(27%) sepia(95%) saturate(7010%) hue-rotate(356deg) brightness(102%) contrast(124%)",
      },
      {
        hex: "#E75F6B",
        filter:
          "invert(45%) sepia(55%) saturate(692%) hue-rotate(306deg) brightness(98%) contrast(85%)",
      },
      {
        hex: "#e91e63",
        filter:
          "invert(22%) sepia(83%) saturate(4165%) hue-rotate(328deg) brightness(94%) contrast(94%)",
      },

      {
        hex: "#ff9800",
        filter:
          "invert(70%) sepia(31%) saturate(6763%) hue-rotate(1deg) brightness(105%) contrast(104%)",
      },
      {
        hex: "#ffeb3b",
        filter:
          "invert(99%) sepia(84%) saturate(7079%) hue-rotate(323deg) brightness(108%) contrast(108%)",
      },
      {
        hex: "#ffff00",
        filter:
          "invert(88%) sepia(60%) saturate(3415%) hue-rotate(352deg) brightness(107%) contrast(105%)",
      },
      {
        hex: "#00ff00",
        filter:
          "invert(68%) sepia(87%) saturate(4327%) hue-rotate(84deg) brightness(122%) contrast(119%)",
      },
      {
        hex: "#4CAF50",
        filter:
          "invert(53%) sepia(79%) saturate(335%) hue-rotate(73deg) brightness(95%) contrast(93%)",
      },
      {
        hex: "#8bc34a",
        filter:
          "invert(78%) sepia(14%) saturate(1669%) hue-rotate(42deg) brightness(91%) contrast(83%)",
      },

      {
        hex: "#87CEEB",
        filter:
          "invert(81%) sepia(13%) saturate(1406%) hue-rotate(165deg) brightness(96%) contrast(92%)",
      },

      {
        hex: "#0000ff",
        filter:
          "invert(8%) sepia(100%) saturate(6585%) hue-rotate(247deg) brightness(113%) contrast(147%)",
      },

      {
        hex: "#3f51b5",
        filter:
          "invert(32%) sepia(14%) saturate(5141%) hue-rotate(207deg) brightness(93%) contrast(94%)",
      },
      {
        hex: "#795548",
        filter:
          "invert(33%) sepia(44%) saturate(385%) hue-rotate(330deg) brightness(93%) contrast(85%)",
      },
      {
        hex: "#A22CFF",
        filter:
          "invert(39%) sepia(83%) saturate(6990%) hue-rotate(266deg) brightness(100%) contrast(104%)",
      },
      {
        hex: "#9c27b0",
        filter:
          "invert(22%) sepia(47%) saturate(3834%) hue-rotate(276deg) brightness(95%) contrast(98%)",
      },
      {
        hex: "#f1f1f1",
        filter:
          "invert(99%) sepia(5%) saturate(357%) hue-rotate(191deg) brightness(115%) contrast(89%)",
      },

      {
        hex: "#5b6671",
        filter:
          "invert(43%) sepia(11%) saturate(587%) hue-rotate(169deg) brightness(86%) contrast(87%)",
      },
      {
        hex: "#bbc2c9",
        filter:
          "invert(78%) sepia(4%) saturate(490%) hue-rotate(169deg) brightness(98%) contrast(96%)",
      },
      {
        hex: "#000000",
        filter:
          "invert(0%) sepia(0%) saturate(0%) hue-rotate(307deg) brightness(97%) contrast(103%)",
      },
    ];
    const store = useStore();
    const showPicker = ref(false);
    const showGallery = ref(false);
    const showG1 = ref(false);
    const showG2 = ref(false);
    const selectedBtns = computed(() => store.getters.selectedButtons);
    const inlayBtns = computed(() => store.getters.currentInlayBtns);
    const img = computed(() => store.getters.imgs);
    const { t } = useI18n();
    function selectedBtnColor() {
      return selectedBtns.value[0]
        ? inlayBtns.value[selectedBtns.value[0]].style.background
        : "";
    }

    const currentStep = ref(30);

    function changeMode() {
      for (let btn in inlayBtns.value) {
        inlayBtns.value[btn].draggable = !inlayBtns.value[btn].draggable;
      }
    }
    function filterIcon(filter) {
      for (let btn in selectedBtns.value) {
        inlayBtns.value[selectedBtns.value[btn]].style.image.filter = filter;
      }
    }

    const gradient = reactive({
      firstColour: "transparent",
      secondColour: "transparent",
    });

    function gradientChange(trigger, event) {
      // if (selectedBtns.value.length > 0) {
      //   gradient.firstColour =
      //     inlayBtns.value[selectedBtns.value[0]].style.gradient["firstColour"];
      //   gradient.secondColour =
      //     inlayBtns.value[selectedBtns.value[0]].style.gradient["secondColour"];
      // }

      if (typeof event === "object") {
        gradient[trigger] = event.colors.hex;
        for (let btn in selectedBtns.value) {
          inlayBtns.value[selectedBtns.value[btn]].style.gradient[trigger] =
            event.colors.hex;
        }
      } else {
        gradient[trigger] = event;
        for (let btn in selectedBtns.value) {
          inlayBtns.value[selectedBtns.value[btn]].style.gradient[trigger] =
            event;
        }
      }
      updateBtn(
        "background",
        "linear-gradient(" +
          gradient.firstColour +
          "," +
          gradient.secondColour +
          ")"
      );
    }
    function calculateGradientColor() {
      // if (selectedBtns.value.length > 0) {
      //   if (
      //     inlayBtns.value[selectedBtns.value[0]].style.background.includes(
      //       "rgb"
      //     )
      //   ) {
      //   }
      // }
      return "";
    }
    function updateBtn(trigger, value) {
      //Abschnitt zum Verändern der Farbe, da Colorpicker Objekt übergibt
      if (typeof value === "object") {
        for (let btn in selectedBtns.value) {
          inlayBtns.value[selectedBtns.value[btn]].style[trigger] =
            value.colors.hex;
        }
        //wenn nicht Colorpicker werden die ausgewählten Buttons entsprechend des Triggers angepasst
      } else {
        for (let btn in selectedBtns.value) {
          inlayBtns.value[selectedBtns.value[btn]].style[trigger] = value;
          store.dispatch("saveInlay");
        }
      }
    }
    function updateBtnImg(trigger, value) {
      for (let btn in selectedBtns.value) {
        inlayBtns.value[selectedBtns.value[btn]].style.image[trigger] = value;
      }
      store.dispatch("saveInlay");
    }

    //Spezielle Funktion für die Skalierung der Button Hintergründe
    function scaleBgImg(value) {
      if (selectedBtns.value.length > 0) {
        if (
          inlayBtns.value[selectedBtns.value[0]].style.image["background-size"]
        ) {
          currentStep.value = parseInt(
            inlayBtns.value[selectedBtns.value[0]].style.image[
              "background-size"
            ].substring(0, 2)
          );
        }
      }

      currentStep.value = currentStep.value + value;

      if (currentStep.value > 20) {
        updateBtnImg("background-size", currentStep.value + "%, cover");
      } else {
        currentStep.value = 20;
        updateBtnImg("background-size", currentStep.value + "%, cover");
      }
    }
    const imgLib = ref([]);
    const showImgLib = ref(false);
    function expandImgLib(lib) {
      library.value = lib;
      showImgLib.value = true;
    }

    function imgURL(img) {
      return process.env.BASE_URL + "images/icons/" + img;
    }
    function changeColor(e) {
      updateBtn("background", e);
    }
    function mouseUp() {
      store.dispatch("saveInlay");
    }
    function selectAllBtns() {
      if (selectedBtns.value.length == inlayBtns.value.length) {
        selectedBtns.value.splice(0, selectedBtns.value.length);
      } else {
        selectedBtns.value.splice(0, selectedBtns.value.length);
        inlayBtns.value.forEach((btn, index) => {
          selectedBtns.value.push(index);
        });
      }
    }
    const duplicating = ref(false);
    function duplicateButton() {
      duplicating.value = true;
      if (selectedBtns.value.length > 1 || selectedBtns.value.length < 1) {
        alert(t("message.duplicateSingle"));
        return;
      }
      let btn = selectedBtns.value[0];
      selectedBtns.value = [];
    }
    return {
      store,
      updateBtn,
      img,
      showImgLib,
      expandImgLib,
      imgLib,
      scaleBgImg,
      imgURL,
      t,
      changeMode,
      showPicker,
      showGallery,
      gradient,
      showG1,
      showG2,
      gradientChange,
      inlayBtns,
      swatchColors,
      filterIcon,
      library,
      updateBtnImg,
      changeColor,
      mouseUp,
      selectedBtns,
      selectedBtnColor,
      buttonBGKey,
      newKey,
      selectAllBtns,
      duplicating,
      duplicateButton,
    };
  },
};
</script>

<style lang="scss" scoped>
.image-library {
  cursor: pointer;
  display: inline-block;
  width: 100px;
  min-height: 90px;
  font-size: small;
  word-break: break-word;
  vertical-align: middle;
}
.swatch-el,
.border-color {
  border: 1px solid grey;
  border-radius: 5px;
  height: 20px;
  width: 20px;
  margin: 3px;
  // margin-left: 15px;
  cursor: pointer;
}
</style>
